jQuery(function($) {
  if ($('.hero__group').length > 0) {
    var heroOptions = $('.hero__group').find('.hero');
    var selectedHeroIdx = Math.floor(Math.random() * heroOptions.length);
    var selectedHero = $(heroOptions[selectedHeroIdx]);

    selectedHero.removeClass('hero--hidden');

    var heroImg = selectedHero.find('.hero__image').attr('data-img');
    var heroAlt = selectedHero.find('.hero__image').attr('data-alt');

    var heroImgTag = $('<img src="' + heroImg + '" alt="' + heroAlt + '" />');

    selectedHero.find('.hero__image').prepend(heroImgTag);
  }
});
